<template>
  <div class="pip_overlay" @click.self="handleEmitClose">
    <div class="pip_modal">

      <div class="pip_header">
        <h2 class="pip_title">プライバシーポリシー</h2>
        <button class="pip_close" @click="handleEmitClose" aria-label="閉じる">✕</button>
      </div>

      <div class="pip_body">
        <p>株式会社MIK（以下，「当社」といいます。）は，本ウェブサイト上で提供するサービス（以下,「本サービス」といいます。）における，ユーザーの個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。</p>

        <h3>第1条（個人情報）</h3>
        <p>「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報及び容貌，指紋，声紋にかかるデータ，及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。</p>

        <h3>第2条（個人情報の収集方法）</h3>
        <p>当社は,応募者が面談等に応募をする際に氏名，生年月日，住所，電話番号，メールアドレスなどの個人情報をお尋ねすることがあります。また，本ウェブサイトの「採用選考におけるハラスメント相談窓口」（以下，「相談窓口」といいます。）をご利用いただく際に，氏名，連絡先，ご相談内容などの情報をお尋ねすることがあります（氏名・連絡先の入力は任意です）。また，ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や決済に関する情報を,当社の提携先（情報提供元，広告主，広告配信先などを含みます。以下，｢提携先｣といいます。）などから収集することがあります。</p>

        <h3>第3条（個人情報を収集・利用する目的）</h3>
        <p>当社が個人情報を収集・利用する目的は，以下のとおりです。</p>
        <ol>
          <li>応募者の方へのご連絡</li>
          <li>応募者の方のお問い合わせに回答するため（本人確認を行うことを含む）</li>
          <li>相談窓口に寄せられたご相談に対応するため（事実関係の確認，相談者の方へのご連絡，行為者に対する措置，再発防止策の検討を含む）</li>
          <li>利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの特定をし，ご利用をお断りするため</li>
          <li>上記の利用目的に付随する目的</li>
        </ol>

        <h3>第3条の2（相談窓口に寄せられた情報の取扱い）</h3>
        <p>当社は，相談窓口に寄せられた情報（以下，「相談情報」といいます。）について，前条の定めに加え，次のとおり取り扱います。</p>
        <ol>
          <li>相談情報は，前条第3号の目的の範囲内でのみ利用します。</li>
          <li>相談情報を取り扱う者は，MIKハラスメント対策委員会およびご相談への対応に必要な最小限の者に限ります。ご本人の同意なく，当該選考の担当者その他の者に相談内容や相談者を特定できる情報を伝えることはありません。</li>
          <li>相談情報には，相談者ご本人のほか，行為者とされる方その他の第三者に関する情報や，心身の状況などの特に配慮を要する情報が含まれる場合があります。当社はこれらの情報についても，本条に従い慎重に取り扱います。</li>
          <li>相談情報は，本ウェブサイト上のデータベースには保存せず，相談窓口宛ての電子メールにより受け付けます。受け付けた相談情報は，対応に必要な期間保管した後，適切な方法により廃棄します。</li>
          <li>当社は，相談窓口を利用したこと，または事実関係の確認に協力したことを理由として，相談者その他の方に対し，採用選考その他において不利益な取扱いをすることはありません。</li>
        </ol>

        <h3>第4条（利用目的の変更）</h3>
        <p>当社は，利用目的が変更前と関連性を有すると合理的に認められる場合に限り，個人情報の利用目的を変更するものとします。利用目的の変更を行った場合には，変更後の目的について，当社所定の方法により，ユーザーに通知し，または本ウェブサイト上に公表するものとします。</p>

        <h3>第5条（個人情報の第三者提供）</h3>
        <p>当社は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。</p>
        <ol>
          <li>人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき</li>
          <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき</li>
          <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
          <li>予め次の事項を告知あるいは公表し，かつ当社が個人情報保護委員会に届出をしたとき
            <ul>
              <li>利用目的に第三者への提供を含むこと</li>
              <li>第三者に提供されるデータの項目</li>
              <li>第三者への提供の手段または方法</li>
              <li>本人の求めに応じて個人情報の第三者への提供を停止すること</li>
              <li>本人の求めを受け付ける方法</li>
            </ul>
          </li>
          <li>前項の定めにかかわらず，次に掲げる場合には，当該情報の提供先は第三者に該当しないものとします。
            <ul>
              <li>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>
              <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
              <li>個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いた場合</li>
            </ul>
          </li>
        </ol>

        <h3>第6条（個人情報の開示）</h3>
        <p>当社は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。なお，個人情報の開示に際しては，1件あたり1，000円の手数料を申し受けます。</p>
        <ol>
          <li>本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合</li>
          <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
          <li>その他法令に違反することとなる場合</li>
        </ol>
        <p>前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。</p>

        <h3>第7条（個人情報の訂正および削除）</h3>
        <p>ユーザーは，当社の保有する自己の個人情報が誤った情報である場合には，当社が定める手続きにより，当社に対して個人情報の訂正，追加または削除（以下，「訂正等」といいます。）を請求することができます。当社は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正等を行うものとします。当社は，前項の規定に基づき訂正等を行った場合，または訂正等を行わない旨の決定をしたときは遅滞なく，これをユーザーに通知します。</p>

        <h3>第8条（個人情報の利用停止等）</h3>
        <p>当社は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行います。前項の調査結果に基づき，その請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の利用停止等を行います。当社は，前項の規定に基づき利用停止等を行った場合，または利用停止等を行わない旨の決定をしたときは，遅滞なく，これをユーザーに通知します。</p>

        <h3>第9条（プライバシーポリシーの変更）</h3>
        <p>本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，ユーザーに通知することなく，変更することができるものとします。当社が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。</p>

        <h3>第10条（お問い合わせ窓口）</h3>
        <p>本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。</p>
        <div class="pip_contact">
          <div>住所：〒001-0014 北海道札幌市北区北十四条西3丁目2-21</div>
          <div>社名：株式会社MIK</div>
          <div>代表取締役：大沼貴明</div>
          <div>担当部署：経営企画室</div>
          <div>Eメールアドレス：keiei_kikaku@mik-s.work</div>
        </div>
        <p>なお，相談窓口に寄せられた相談情報の取扱いに関するお問い合わせは，MIKハラスメント対策委員会（harassment@mik-s.jp）までお願いいたします。</p>
      </div>

      <div class="pip_footer">
        <button class="pip_close_btn" @click="handleEmitClose">閉じる</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  emits: ['close-pip'],
  methods: {
    handleEmitClose() {
      this.$emit('close-pip');
    }
  }
}
</script>

<style scoped>
.pip_overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  box-sizing: border-box;
}

.pip_modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 640px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.pip_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.pip_title {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
}

.pip_close {
  background: #f0f0f0;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 200ms;
  color: #555;
}
.pip_close:hover { background: #e0e0e0; color: #000; }

.pip_body {
  overflow-y: auto;
  padding: 24px 28px;
  font-size: 13.5px;
  line-height: 1.8;
  color: #444;
  flex: 1;
}

.pip_body h3 {
  font-size: 14px;
  font-weight: bold;
  color: #2c3e50;
  margin: 20px 0 8px;
  padding-left: 10px;
  border-left: 3px solid #0cc0df;
}

.pip_body p, .pip_body ol, .pip_body ul {
  margin: 0 0 10px;
  padding-left: 20px;
}

.pip_body li { margin-bottom: 4px; }

.pip_contact {
  background: #f7f9fc;
  border-radius: 8px;
  padding: 14px 18px;
  margin-top: 8px;
  line-height: 2;
}

.pip_footer {
  padding: 16px 28px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.pip_close_btn {
  padding: 10px 48px;
  background: linear-gradient(135deg, #0cc0df, #0890a8);
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 200ms;
}
.pip_close_btn:hover { transform: translateY(-1px); box-shadow: 0 4px 14px rgba(12,192,223,0.35); }

@media (max-width: 600px) {
  .pip_modal { max-height: 90vh; border-radius: 12px; }
  .pip_header, .pip_body, .pip_footer { padding-left: 18px; padding-right: 18px; }
}
</style>
